define('components/asset-player/views/assets/asset-views',[
    'components/asset-player/views/assets/audio',
    'components/asset-player/views/assets/image',
    'components/asset-player/views/assets/video'
], function (Audio, Image, Video) {
    "use strict";

    return {
        "Audio": Audio,
        "Image": Image,
        "Video": Video
    };
});

